<div *ngIf="currentCalendarWeekData && referenceOperation" class="close_tours_container" style="color: white; background-color: #3f3f3f;" >
  <div *ngIf="updatingTechnicianDates || updatingTravelTechnicianDates" style="position:absolute; pointer-events: none; top: 0; right: 0; width: 40px; height: 40px;">
    <hawk-throbber [description]="''"></hawk-throbber>
  </div>
  <div style="margin: auto" *ngIf="
    !closeTechnicianDateWeekdays.monday &&
    !closeTechnicianDateWeekdays.tuesday &&
    !closeTechnicianDateWeekdays.wednesday &&
    !closeTechnicianDateWeekdays.thursday &&
    !closeTechnicianDateWeekdays.friday &&
    !closeTechnicianDateWeekdays.saturday &&
    !closeTechnicianDateWeekdays.sunday
  ">
    <h6>Keine geplanten nahen Touren/Aufträge</h6>
  </div>
  <div class="flex_row w-full">
    <ng-container *ngFor="let weekday of PATimeControl.Instance.weekDays">
      <div class="flex_col" style="max-width: 20%;" *ngIf="closeTechnicianDateWeekdays[weekday]">
        <div class="w-full relative">
          <h4 class="w-full" style="text-align: center; font-size: 1rem;">{{PATimeControl.Instance.weekDayToGermanName(weekday, true)}} {{PATimeControl.Instance.timestampToDatestring(currentCalendarWeekData.weekdays[weekday].timestamp, false, '.')}}</h4>
        </div>
        <div *ngFor="let close_technician_date of closeTechnicianDateWeekdays[weekday]"
             class="close_tour" (click)="clickTechnicianDate.emit(close_technician_date.technician_date)"
             [ngClass]="(tourComparisonsIncludeTechnicianDate(close_technician_date.technician_date) ? 'selected bg-primary' : 'black_gradient_background')"
        >
          <div style="text-align: center; display: inline-flex; flex-direction: row">
            <div style="margin: auto; flex: 1;">
              {{close_technician_date.technician_date.technician.getFullName()}}
            </div>
            <div *ngIf="close_technician_date.travel_technician_date_type"
                 style="background-size: 100%; width: 24px; height: 24px; margin: auto 6px auto 6px;position: relative;"
                 class="destination_background_container"
                 [tooltip]="'Reisetechniker-Tag: ' + close_technician_date.travel_technician_date_type"
            >
              <div class="destination_background"></div>
              <div class="destination_background_border"></div>
            </div>
          </div>
          <div style="white-space: nowrap; margin: auto;" [ngClass]="close_technician_date.technician_date?.tour?.workloadClass">
            {{close_technician_date.technician_date?.tour?.workloadString}}
          </div>
          <div style="white-space: nowrap; margin: auto; padding-left: 3px;">
            Entf. {{Math.round(close_technician_date.distance_km)}}km
          </div>
        </div>
      </div>

    </ng-container>
  </div>

</div>
